import React from 'react';
import LabelAction from '@/components/label-action';
import { useLocaleStore } from '@/i18n';
import { type ListStyleStruct } from '@/types';
import { type WidgetCommonProps } from '../../types';
import {
    FontFamily,
    FontSize,
    FontStyle,
    ListStyle,
    TextAlignment,
    TextColorPicker,
    TextOpacity,
    TextPadding,
    TextSpacing,
} from '../../widgets';
import './style.less';
import { FontItem } from '@meitu/xdesign-widgets';

type Props = WidgetCommonProps & {
    fonts: FontItem[];
    listStyles: ListStyleStruct[];
    enableRemoteSearch?: boolean;
};

export const VectorTextPanel: React.FC<Props> = ({ fonts, listStyles, enableRemoteSearch, ...commonProps }) => {
    const { $t } = useLocaleStore();

    return (
        <div className="vector-text-panel">
            <div className="vector-text-panel__base">
                <FontFamily fonts={fonts} enableRemoteSearch={enableRemoteSearch} {...commonProps} />
                <LabelAction title={$t((v) => v.textFontSizeAndTextColor.size)} align>
                    <div className="vector-text-panel__ctrl">
                        <FontSize {...commonProps} />
                        <TextColorPicker {...commonProps} />
                    </div>
                </LabelAction>
                <FontStyle {...commonProps} />
                <TextAlignment {...commonProps} />
                <LabelAction title={$t((v) => v.textAction.spacing)} align>
                    <div className="vector-text-panel__ctrl">
                        <TextSpacing {...commonProps} />
                        <ListStyle listStyles={listStyles} {...commonProps} />
                    </div>
                </LabelAction>
                <TextPadding {...commonProps} />
                <TextOpacity {...commonProps} />
            </div>
        </div>
    );
};
